import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';

import { modifierList, tagList } from './props-list';

const DEFAULT_TAG = 'h2';
const DEFAULT_MODIFIERS = [];

const SectionTitle = ({ children, tag = DEFAULT_TAG, modifiers = DEFAULT_MODIFIERS }) => {
  const classNames = getClassNames('c-section-title', modifiers);
  const Tag = tag;

  return (
    <Tag className={classNames} data-shadow={children}>
      {children}
    </Tag>
  );
};

SectionTitle.propTypes = {
  children: PropTypes.any.isRequired,
  tag: PropTypes.oneOf(tagList),
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
};

export default SectionTitle;
